import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Select from '../../Select';
import { FilterTypes } from '../Components';
import { isUndefined } from '../../../utils/js';

class SelectFilter extends Component {
  constructor(props) {
    super(props);

    this.refSelect = createRef();
  }

  handleChange = (evt, value, additionalData) => {
    const { addFilter, item } = this.props;

    addFilter && addFilter(
      item.propertyName,
      item.queryOption,
      {
        target: {
          value,
          displayValue: additionalData,
          name: item.description,
        },
      },
      null,
      null,
      FilterTypes.SELECT,
      item.customFilter,
    );

    this.refSelect.clear();
  };

  render() {
    const {
      item,
      title,
      ...others
    } = this.props;

    return (
      <div className="filter__campoRicerca" style={item.width && { width: item.width.toString() }}>
        <div className="select">
          <Select
            onChange={this.handleChange}
            ref={(r) => { this.refSelect = r; }}
            title={item.description}
            {...others}
          >
            {item.options && item.options.map((x, i) => (
              <Select.Option
                additionalData={x.description}
                key={i} // eslint-disable-line react/no-array-index-key
                value={isUndefined(x.value) ? x.description : x.value}
              >
                {x.description}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    );
  }
}

SelectFilter.propTypes = {
  /** Callback invocata all'aggiunta di un termine di filtro */
  addFilter: PropTypes.func.isRequired,
  /** Titolo */
  title: PropTypes.string,
  /** Descrittore del filtro da applicare */
  item: PropTypes.shape({
    propertyName: PropTypes.string.isRequired,
    description: PropTypes.string,
    width: PropTypes.number,

    // eslint-disable-next-line react/forbid-prop-types
    customFilter: PropTypes.array,
    // eslint-disable-next-line react/forbid-prop-types
    options: PropTypes.array,
    // eslint-disable-next-line react/forbid-prop-types
    queryOption: PropTypes.array,

  }).isRequired,
};

SelectFilter.defaultProps = {
  title: undefined,
};

export default SelectFilter;
